import { LoaderProps } from './Loader.types'
import { ModalBoxProps } from '../ModalBox/ModalBox.types'
import {
  LoaderIcon,
  LoaderLabel,
  LoaderLogo,
  LoaderWrapper
} from './Loader.styles'
import { isString } from '../../../utils'
import useId from '../../hooks/useId'

const Loader = ({
  className = '',
  show = false,
  fullScreen = true,
  logo,
  modalBox,
  label,
  styles,
  hideIcon = false,
  'data-testid': testid = 'loader',
  ...props
}: LoaderProps) => {
  const { getTestId } = useId(testid)
  const modalBoxProps: Partial<ModalBoxProps> = {
    fullScreen,
    padding: fullScreen ? 0 : 48,
    ...props,
    ...modalBox
  }
  const logoProps = isString(logo) ? { src: logo } : logo
  const labelProps = isString(label) ? { value: label } : label

  return (
    <LoaderWrapper
      className={`Loader ${className}`}
      open={show}
      sx={styles}
      data-testid={getTestId()}
      {...modalBoxProps}>
      {logoProps && (
        <LoaderLogo
          className="LoalderLogo"
          data-testid={getTestId('logo')}
          {...logoProps}
        />
      )}
      {!hideIcon && (
        <LoaderIcon className="LoaderIcon" data-testid={getTestId('icon')} />
      )}
      {labelProps && (
        <LoaderLabel
          className="LoaderLabel"
          data-testid={getTestId('label')}
          {...labelProps}
        />
      )}
    </LoaderWrapper>
  )
}

export default Loader
